import { palette } from "../../Theme/palette";
export const MuiTableRow = {
    styleOverrides: {
        root: { "&:hover": { backgroundColor: palette.action.hover } }
    }
};
//# sourceMappingURL=TableRow.js.map